import { onMounted, onUpdated, onBeforeUnmount } from 'vue';
import TextAnimator from '@/js/hover-effect/text-animator';

let hoverEffects = [];
let animators = new Map();

const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
};

export function hoverEffect() {
    const initHoverEffects = () => {
        hoverEffects = Array.from(document.querySelectorAll('.hover-effect'));

        hoverEffects.forEach(item => {
            if (!animators.has(item)) {
                const animator = new TextAnimator(item);
                animators.set(item, animator);

                item.addEventListener('mouseenter', debounce(() => {
                    animator.animate();
                }, 100));

                item.addEventListener('mouseleave', debounce(() => {
                    animator.animateBack();
                }, 100));
            }
        });
    };

    const cleanupHoverEffects = () => {
        hoverEffects.forEach(item => {
            if (animators.has(item)) {
                const animator = animators.get(item);
                item.removeEventListener('mouseenter', animator.animate);
                item.removeEventListener('mouseleave', animator.animateBack);
                animators.delete(item);
            }
        });
        hoverEffects = [];
    };

    onMounted(initHoverEffects);
    onUpdated(initHoverEffects);
    onBeforeUnmount(cleanupHoverEffects);
}